import {
    FETCH_EXTERNAL_PRACTITIONER_LIST_REQUEST,
    FETCH_EXTERNAL_PRACTITIONER_LIST_SUCCESS,
    FETCH_EXTERNAL_PRACTITIONER_LIST_FAILURE,
  } from "./FetchExternalPractitionerTypes";
  
  const initialState = {
    loading: false,
    externalPractitionerList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_EXTERNAL_PRACTITIONER_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_EXTERNAL_PRACTITIONER_LIST_SUCCESS:
        return {
          loading: false,
          externalPractitionerList: action.payload,
          error: "",
        };
      case FETCH_EXTERNAL_PRACTITIONER_LIST_FAILURE:
        return {
          loading: false,
          externalPractitionerList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  